export const getTotalPages = (totalItems: number, limit: number) => Math.ceil(totalItems / limit);

export const generatePages = (totalPages: number) =>
  [...Array(totalPages)].map((_, index) => index + 1);

export const getPageOffset = (pageNumber: number, limit: number) => (pageNumber - 1) * limit;

export const getCurrentPage = (offset: number, limit: number) => getTotalPages(offset, limit);
